<script setup lang="ts">
import { RouterLink } from 'hybridly/vue'

const { matches } = useRoute()
</script>

<template>
	<div class="mb-4 flex flex-wrap gap-4 border-b pb-4">
		<ui-button
			:as="RouterLink"
			:href="route('user-profile-information.show')"
			:variant="//@ts-ignore
				matches('user-profile-information.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.profile') }}
		</ui-button>
		<ui-button
			:as="RouterLink"
			:href="route('user-preferences.show')"
			:variant="//@ts-ignore
				matches('user-preferences.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.preferences') }}
		</ui-button>
		<ui-button
			:as="RouterLink"
			:href="route('user-password.show')"
			:variant="//@ts-ignore
				matches('user-password.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.password') }}
		</ui-button>
		<ui-button
			:as="RouterLink"
			:href="route('user-sessions.show')"
			:variant="//@ts-ignore
				matches('user-sessions.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.sessions') }}
		</ui-button>
	</div>
</template>
